import { IonFooter, IonToolbar } from '@ionic/react';
import type { ReactNode } from 'react';
import styles from './ModalFooter.module.css';

/**
 * Sticky card-style modal footer holding the primary action button(s).
 * Buttons inside should use this module's primaryButton/ghostButton classes.
 */
const ModalFooter: React.FC<{ children: ReactNode }> = ({ children }) => (
    <IonFooter className={styles.footer}>
        <IonToolbar className={styles.toolbar}>{children}</IonToolbar>
    </IonFooter>
);

export default ModalFooter;
